/*	
	App configuration file

	Although this App is by itself (or beyond en and tc),
	but as of 1/23/2021 it's attached to en site. So the site url is en.

	This Configuration file will not be just for the frontend app form,
	but also to be used for the backend once backend
	(Tablets Manager for the staff) is also handled by React.(2/5/2021)

	Date created: 1/23/2021; Last Update: 2/5/2021

	prod site:
	const mainSiteLink = "https://www.baus.org";
	aboutUsLink: "https://www.baus.org/en/about-us/",
	contactUsLink: "https://www.baus.org/en/about-us/contact-us/"

	dev site:
	const mainSiteLink = "https://baus.ilotus.org";
	aboutUsLink: "https://baus.ilotus.org/en/about-us/",
	contactUsLink: "https://baus.ilotus.org/en/about-us/contact-us/"

	local site:
	const mainSiteLink = "http://localhost/baus";
	aboutUsLink: "http://localhost/baus/en/about-us/",
	contactUsLink: "http://localhost/baus/en/about-us/'contact-us/"

*/

const mainSiteLink = "https://www.baus.org";
//const mainSiteLink = "https://baus.ilotus.org";
//const mainSiteLink = "http://localhost/baus";

const appConfig = {
  siteSet: {
    title: "BAUS",
    titleC: "美國佛教會",
    link: mainSiteLink + "/en",
  },
  pageSet: {
    aboutUsLink: mainSiteLink + "/en/about-us/",
    contactUsLink: mainSiteLink + "/en/about-us/contact-us/",
    servicesLink: mainSiteLink + "/en/about-us/services/",
  },
  appSet: {
    title: "Tablets",
    titleC: "法會消災、超薦、供僧登記表",
    link: mainSiteLink + "/tablets",
    tablets: ["Tablets", "牌位"],
    xiaozai: ["for the blessing", "消災"],
    wangsheng: ["for delivering the deceased", "超薦"],
  },
  formSet: {
    title: "Tablets for Ceremony App Form",
    title_c: "法會消災、超薦、供僧登記表",
    title2: "Tablets for Ceremony",
    title2_c: "法會消災、超薦、供僧",
    link: mainSiteLink + "/tablets-form.html",
  },
  dbFields: [
    "contact[0][1]",
    "contact[0][1]",
    "contact[0][2]",
    "donor_contact",
    "contact[1][0]",
    "contact[1][1]",
    "contact[1][2]",
    "xiaozai[0][0]",
    "xiaozai[0][1]",
    "xiaozai[1][0]",
    "xiaozai[1][1]",
    "xiaozai[2][0]",
    "xiaozai[2][1]",
    "wangsheng[0][0]",
    "wangsheng[0][1]",
    "wangsheng[1][0]",
    "wangsheng[1][1]",
    "wangsheng[2][0]",
    "wangsheng[2][1]",
    "wangsheng[3][0]",
    "wangsheng[3][1]",
    "wangsheng[4][1]",
    "wangsheng[5][1]",
    "wangsheng[6][0]",
    "wangsheng[6][1]",
    "wangsheng[7][0]",
    "wangsheng[7][1]",
    "misc[sangha]",
    "misc[ceremony]",
    "misc[flowerfruit]",
    "comments",
  ],
};

/*
1.   `id` smallint(6) NOT NULL,
2.   `case_id` varchar(40) NOT NULL,
3.   `date_created` datetime NOT NULL,
4.   `last_update` datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
5.   `updated_by` varchar(16) DEFAULT NULL,
6.   `d_name` varchar(70) NOT NULL,
7.   `d_email` varchar(70) NOT NULL,
8.   `d_phone` varchar(30) NOT NULL,
9.   `same_contact` tinyint(4) NOT NULL DEFAULT '0',
10.   `c_name` varchar(70) DEFAULT NULL,
11.   `c_email` varchar(70) DEFAULT NULL,
12.   `c_phone` varchar(30) DEFAULT NULL,
13.   `tblt_price` float DEFAULT NULL,
14.   `tblt_num` tinyint(4) DEFAULT '0',
15.   `xiaozai_1` varchar(36) DEFAULT NULL,
16.   `xiaozai_2` varchar(36) DEFAULT NULL,
17.   `xiaozai_3` varchar(36) DEFAULT NULL,
18.   `tblt2_price` float DEFAULT NULL,
19.   `tblt2_num` tinyint(4) DEFAULT '0',
20.   `wangsheng_1` varchar(36) DEFAULT NULL,
21.   `wangsheng_2` varchar(36) DEFAULT NULL,
22.   `wangsheng_3` varchar(36) DEFAULT NULL,
23.   `wangsheng_4` varchar(36) DEFAULT NULL,
24.   `wangsheng_5` varchar(36) DEFAULT NULL,
25.   `wangsheng_6` varchar(36) DEFAULT NULL,
26.   `wangsheng_7` varchar(36) DEFAULT NULL,
27.   `wangsheng_8` varchar(36) DEFAULT NULL,
28.   `sangha` float DEFAULT '0',
29.   `flowerfruit` float DEFAULT '0',
30.   `ceremony` float DEFAULT '0',
31.   `comments` varchar(255) DEFAULT NULL,
32.   `status` tinyint(4) NOT NULL DEFAULT '1',
33.   `paid_amt` float DEFAULT '0'

32 & 33 are not fields on Form inputs
----------------------------------------------------

const tempForm = new FormData(event.target);
for (let [key, value] of tempForm.entries()) { 
	console.log(key, value); 
} 

Total number could be either 28 or 30 depending on if door_contact present or not
1. contact[0][0] 1
2. contact[0][1] 2@b.c
3. contact[0][2] 3
4. contact[1][0] 4     // these three could be unidentified if donor_contact is present
5. contact[1][1] 5@b.c // could be undefined
6. contact[1][2] 6     // could be undefined
7. xiaozai[0][0] 7
8. xiaozai[0][1] 8
9. xiaozai[1][0] 9
10. xiaozai[1][1] 0
11. xiaozai[2][0] 1
12. xiaozai[2][1] 2
13. wangsheng[0][0] 3
14. wangsheng[0][1] 4
15. wangsheng[1][0] 5
16. wangsheng[1][1] 6
17. wangsheng[2][0] 7
18. wangsheng[2][1] 8
19. wangsheng[3][0] 9
20. wangsheng[3][1] 0
21. wangsheng[4][1] 1
22. wangsheng[5][1] 2
23. wangsheng[6][0] 3
24. wangsheng[6][1] 4
25. wangsheng[7][0] 5
26. wangsheng[7][1] 6
27. misc[sangha] 7
28. misc[ceremony] 8
29. misc[flowerfruit] 9
30. comments 0

*/
export default appConfig;
